if (!customElements.get('smileyrush-announcement')) {
  customElements.define('smileyrush-announcement', class extends HTMLElement {
    connectedCallback() {
      this.stopTimer();
      this.deadline = Date.parse(this.dataset.deadline);
      this.countdown = this.querySelector('[data-countdown]');
      this.activeHeading = this.querySelector('[data-active-heading]');
      this.expiredHeading = this.querySelector('[data-expired-heading]');
      this.saleMessages = this.querySelectorAll('[data-sale-only]');
      this.units = Object.fromEntries(
        [...this.querySelectorAll('[data-countdown-unit]')].map((element) => [element.dataset.countdownUnit, element])
      );
      this.handleVisibility = this.handleVisibility || (() => {
        this.stopTimer();
        if (!document.hidden) this.tick();
      });
      document.addEventListener('visibilitychange', this.handleVisibility);
      this.tick();
    }

    disconnectedCallback() {
      this.stopTimer();
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    stopTimer() {
      window.clearTimeout(this.timer);
      this.timer = null;
    }

    tick() {
      this.stopTimer();
      const now = Date.now();
      let cycleDeadline = this.deadline;
      if (this.dataset.repeatDaily === 'true' && Number.isFinite(cycleDeadline) && cycleDeadline > 0 && cycleDeadline <= now) {
        const elapsedCycles = Math.floor((now - cycleDeadline) / 86400000) + 1;
        cycleDeadline += elapsedCycles * 86400000;
      }
      const remaining = cycleDeadline - now;
      const active = Number.isFinite(remaining) && remaining > 0;
      this.dataset.saleActive = String(active);
      if (this.activeHeading) this.activeHeading.hidden = !active;
      if (this.expiredHeading) this.expiredHeading.hidden = active;
      this.saleMessages.forEach((message) => { message.hidden = !active; });
      if (this.countdown) this.countdown.hidden = !active || this.dataset.countdownEnabled !== 'true';

      if (!active) return;

      const totalSeconds = Math.max(0, Math.ceil(remaining / 1000));
      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60
      };
      Object.entries(values).forEach(([unit, value]) => {
        if (this.units[unit]) this.units[unit].textContent = String(value).padStart(2, '0');
      });

      if (!document.hidden) {
        this.timer = window.setTimeout(() => this.tick(), Math.min(remaining, 1000 - (Date.now() % 1000) + 10));
      }
    }

  });
}
